export var DiceAdjustmentTypeEnum;
(function (DiceAdjustmentTypeEnum) {
    DiceAdjustmentTypeEnum["ADVANTAGE"] = "ADVANTAGE";
    DiceAdjustmentTypeEnum["DISADVANTAGE"] = "DISADVANTAGE";
    DiceAdjustmentTypeEnum["BONUS"] = "BONUS";
})(DiceAdjustmentTypeEnum || (DiceAdjustmentTypeEnum = {}));
export var UsableDiceAdjustmentTypeEnum;
(function (UsableDiceAdjustmentTypeEnum) {
    UsableDiceAdjustmentTypeEnum["NONE"] = "NONE";
    UsableDiceAdjustmentTypeEnum["ADVANTAGE"] = "ADVANTAGE";
    UsableDiceAdjustmentTypeEnum["DISADVANTAGE"] = "DISADVANTAGE";
    UsableDiceAdjustmentTypeEnum["ADVANTAGE_DISADVANTAGE"] = "ADVANTAGE_DISADVANTAGE";
})(UsableDiceAdjustmentTypeEnum || (UsableDiceAdjustmentTypeEnum = {}));
export var DiceAdjustmentRollTypeEnum;
(function (DiceAdjustmentRollTypeEnum) {
    DiceAdjustmentRollTypeEnum["NONE"] = "NONE";
    DiceAdjustmentRollTypeEnum["SAVE"] = "SAVE";
    DiceAdjustmentRollTypeEnum["STAT_SAVE"] = "STAT_SAVE";
    DiceAdjustmentRollTypeEnum["DEATH_SAVE"] = "DEATH_SAVE";
    DiceAdjustmentRollTypeEnum["ABILITY_CHECK"] = "ABILITY_CHECK";
})(DiceAdjustmentRollTypeEnum || (DiceAdjustmentRollTypeEnum = {}));
